/**
 * Export loadData calls from ducks modules of different containers
 */
import {
  loadData as ArtistProfileLoader,
  loadClientData as ArtistProfileClientLoader,
} from './CreatorProfilePage/CreatorProfilePage.duck';
import { loadData as InsightsPageLoader } from './InsightsPage/InsightsPage.duck';
import { loadData as AudienceConversationsPageLoader } from './AudienceConversationsPage/AudienceConversationsPage.duck';
import {
  setInitialValues as BookingPageInitialValues,
  loadData as BookingPageLoader,
} from './BookingPage/BookingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CalendarPageLoader } from './CalendarPage/CalendarPage.duck';
import {
  loadData as CommentsPageLoader,
  loadClientData as CommentsPageClientLoader,
} from './CommentsPage/CommentsPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditPostPageLoader } from './EditPostPage/EditPostPage.duck';
import { loadData as EditLiveRoomPageLoader } from './EditLiveRoomPage/EditLiveRoomPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as AccountNotificationsPageLoader } from './AccountNotificationsPage/TurnedOffEmails.duck';
import { loadData as EmailSettingsPageLoader } from './EmailSettingsPage/EmailSettingsPage.duck';
import { loadData as EmailTurnOffPageLoader } from './EmailTurnOffPage/EmailTurnOffPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import {
  loadData as LiveRoomPageLoader,
  loadClientData as LiveRoomPageClientLoader,
} from './LiveRoomPage/LiveRoomPage.duck';
import {
  loadData as LandingPageLoader,
  loadClientData as LandingPageClientLoader,
} from './LandingPage/LandingPage.duck';
import {
  loadData as ListingPageLoader,
  loadClientData as ListingPageClientLoader,
} from './ListingPage/ListingPage.duck';
import { loadData as ManageSubscriptionsLoader } from './ManageSubscriptionsPage/ManageSubscriptionsPage.duck';
import { loadData as MembersPageLoader } from './MembersPage/MembersPage.duck';
import { loadData as MeetPageLoader } from './MeetPage/MeetPage.duck';
import {
  loadData as OrganizationProfileLoader,
  loadClientData as OrganizationProfileClientLoader,
} from './OrganizationProfilePage/OrganizationProfilePage.duck';
import { loadData as OrgSettingsPageLoader } from './OrgSettingsPage/OrgSettingsPage.duck';
import { loadData as OrgSettingsTeamsPageLoader } from './OrgSettingsPage/OrgSettingsTeamsPage.duck';
import { loadData as OrgSettingsAssignmentsPageLoader } from './OrgSettingsPage/OrgSettingsAssignmentsPage.duck';
import { loadData as OrgSettingsNotificationsPageLoader } from './OrgSettingsPage/OrgSettingsNotificationsPage.duck';
import { loadData as OrgSettingsConfigurationsPageLoader } from './OrgSettingsPage/OrgSettingsConfigurationsPage.duck';
import { loadData as CreatorSettingsNotificationsPageLoader } from './CreatorSettingsPage/CreatorSettingsNotificationsPage.duck';
import { loadData as CreatorSettingsConfigurationsPageLoader } from './CreatorSettingsPage/CreatorSettingsConfigurationsPage.duck';
import { loadData as CreatorSettingsBillingPageLoader } from './CreatorSettingsPage/CreatorSettingsBillingPage.duck';
import { loadData as CreatorSettingsAssignmentsPageLoader } from './CreatorSettingsPage/CreatorSettingsAssignmentsPage.duck';
import { loadData as CreatorAudiencePageLoader } from './CreatorAudiencePage/CreatorAudiencePage.duck';
import { loadData as OrgAudiencePageLoader } from './OrgAudiencePage/OrgAudiencePage.duck';
import { loadData as OrgSettingsBillingPageLoader } from './OrgSettingsPage/OrgSettingsBillingPage.duck';
import { loadData as PaymentHistoryPageLoader } from './PaymentHistoryPage/PaymentHistoryPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import {
  loadData as ProfilePageLoader,
  loadClientData as ProfilePageClientLoader,
} from './ProfilePage/ProfilePage.duck';
import { loadData as QuickRepliesLoader } from './QuickRepliesPage/QuickRepliesPage.duck';
import {
  loadData as ReviewsPageLoader,
  loadClientData as ReviewsPageClientLoader,
} from './ReviewsPage/ReviewsPage.duck';
import { loadData as VerifyListingInvitePageLoader } from './VerifyListingInvitePage/VerifyListingInvitePage.duck';
import {
  loadData as VerifyOrganizationInvitePageLoader,
  loadClientData as VerifyOrganizationInvitePageClientLoader,
} from './VerifyOrganizationInvitePage/VerifyOrganizationInvitePage.duck';
import {
  loadData as HostsPageLoader,
  loadClientData as HostsPageClientLoader,
} from './HostsPage/HostsPage.duck';
import {
  loadData as CommunityPageLoader,
  loadClientData as CommunityPageClientLoader,
} from './CommunityPage/CommunityPage.duck';
import {
  loadData as PostPageLoader,
  loadClientData as PostPageClientLoader,
} from './PostPage/PostPage.duck';
import { loadData as WatchlistPageLoader } from './WatchlistPage/WatchlistPage.duck';
import { loadData as OrganizationHomePageLoader } from './OrganizationHomePage/OrganizationHomePage.duck';
import { loadData as CreatorHomePageLoader } from './CreatorHomePage/CreatorHomePage.duck';
import { loadData as CreatorListingsPageLoader } from './CreatorListingsPage/CreatorListingsPage.duck';
import { loadData as CreatorCalendarPageLoader } from './CreatorCalendarPage/CreatorCalendarPage.duck';
import { loadData as CreatorConversationsPageLoader } from './CreatorConversationsPage/CreatorConversationsPage.duck';
import { loadData as OrgManageShowsPageLoader } from './OrgShowsPage/OrgShowsPage.duck';
import { loadData as OrgCalendarPageLoader } from './OrgCalendarPage/OrgCalendarPage.duck';
import { loadData as OrgConversationsPageLoader } from './OrgConversationsPage/OrgConversationsPage.duck';
import { loadData as UpgradePageLoader } from './UpgradePage/UpgradePage.duck';

const getPageDataLoadingAPI = () => {
  return {
    CreatorProfilePage: {
      loadData: ArtistProfileLoader,
      loadClientData: ArtistProfileClientLoader,
    },
    InsightsPage: {
      loadData: InsightsPageLoader,
    },
    AudienceConversationsPage: {
      loadData: AudienceConversationsPageLoader,
    },
    BookingPage: {
      loadData: BookingPageLoader,
      setInitialValues: BookingPageInitialValues,
    },
    CalendarPage: {
      loadData: CalendarPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CommentsPage: {
      loadData: CommentsPageLoader,
      loadClientData: CommentsPageClientLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditPostPage: {
      loadData: EditPostPageLoader,
    },
    EditLiveRoomPage: {
      loadData: EditLiveRoomPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    AccountNotificationsPage: {
      loadData: AccountNotificationsPageLoader,
    },
    EmailSettingsPage: {
      loadData: EmailSettingsPageLoader,
    },
    EmailTurnOffPage: {
      loadData: EmailTurnOffPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    LiveRoomPage: {
      loadData: LiveRoomPageLoader,
      loadClientData: LiveRoomPageClientLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
      loadClientData: LandingPageClientLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
      loadClientData: ListingPageClientLoader,
    },
    ManageSubscriptionsPage: {
      loadData: ManageSubscriptionsLoader,
    },
    WatchlistPage: {
      loadData: WatchlistPageLoader,
    },
    MembersPage: {
      loadData: MembersPageLoader,
    },
    MeetPage: {
      loadData: MeetPageLoader,
    },
    OrganizationProfilePage: {
      loadData: OrganizationProfileLoader,
      loadClientData: OrganizationProfileClientLoader,
    },
    OrgSettingsProfilePage: {
      loadData: OrgSettingsPageLoader,
    },
    OrgSettingsTeamsPage: {
      loadData: OrgSettingsTeamsPageLoader,
    },
    OrgSettingsNotificationsPage: {
      loadData: OrgSettingsNotificationsPageLoader,
    },
    OrgSettingsConfigurationsPage: {
      loadData: OrgSettingsConfigurationsPageLoader,
    },
    OrgSettingsAssignmentsPage: {
      loadData: OrgSettingsAssignmentsPageLoader,
    },
    OrgSettingsBillingPage: {
      loadData: OrgSettingsBillingPageLoader,
    },
    CreatorSettingsNotificationsPage: {
      loadData: CreatorSettingsNotificationsPageLoader,
    },
    CreatorSettingsConfigurationsPage: {
      loadData: CreatorSettingsConfigurationsPageLoader,
    },
    CreatorSettingsBillingPage: {
      loadData: CreatorSettingsBillingPageLoader,
    },
    CreatorSettingsAssignmentsPage: {
      loadData: CreatorSettingsAssignmentsPageLoader,
    },
    CreatorAudiencePage: {
      loadData: CreatorAudiencePageLoader,
    },
    OrgAudiencePage: {
      loadData: OrgAudiencePageLoader,
    },
    PaymentHistoryPage: {
      loadData: PaymentHistoryPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
      loadClientData: ProfilePageClientLoader,
    },
    QuickRepliesPage: {
      loadData: QuickRepliesLoader,
    },
    ReviewsPage: {
      loadData: ReviewsPageLoader,
      loadClientData: ReviewsPageClientLoader,
    },
    VerifyListingInvitePage: {
      loadData: VerifyListingInvitePageLoader,
    },
    VerifyOrganizationInvitePage: {
      loadData: VerifyOrganizationInvitePageLoader,
      loadClientData: VerifyOrganizationInvitePageClientLoader,
    },
    HostsPage: {
      loadData: HostsPageLoader,
      loadClientData: HostsPageClientLoader,
    },
    CommunityPage: {
      loadData: CommunityPageLoader,
      loadClientData: CommunityPageClientLoader,
    },
    PostPage: {
      loadData: PostPageLoader,
      loadClientData: PostPageClientLoader,
    },
    OrganizationHomePage: {
      loadData: OrganizationHomePageLoader,
    },
    CreatorHomePage: {
      loadData: CreatorHomePageLoader,
    },
    CreatorListingsPage: {
      loadData: CreatorListingsPageLoader,
    },
    CreatorCalendarPage: {
      loadData: CreatorCalendarPageLoader,
    },
    CreatorConversationsPage: {
      loadData: CreatorConversationsPageLoader,
    },
    OrgManageShowsPage: {
      loadData: OrgManageShowsPageLoader,
    },
    OrgCalendarPage: {
      loadData: OrgCalendarPageLoader,
    },
    OrgConversationsPage: {
      loadData: OrgConversationsPageLoader,
    },
    UpgradePage: {
      loadData: UpgradePageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
